import React, { useContext } from "react";
import { Model } from "../../../Widgets";
import { Empty } from "antd";
import CartContext from "../../../Provider/CartProvider";

const ViewCoupon = ({ cartlist = [] }) => {
  const { viewCouponPopup, setViewCouponPopup } = useContext(CartContext);
  return (
    <Model
      open={viewCouponPopup}
      oncancel={() => setViewCouponPopup(false)}
      title={"Coupon List"}
      body={
        <>
          {cartlist?.length === 0 && (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No Coupon Found"
              className=""
              style={{
                width: "100%",
                border: "1px solid #f0f0f0",
                padding: "50px 20px",
                borderRadius: "12px",
                margin: "0",
              }}
            />
          )}
          {cartlist?.map((e, i) => {
            return (
              <div key={i} className="coupon_list">
                <div className="left">
                  {i + 1}. Shop for &#x20B9;{e?.to_amount} more to apply{" "}
                  {e?.discount_persentage}% off{" "}
                </div>
                <div className="right">
                  {/* <button>Apply</button> */}
                  <b>{e?.coupon_code}</b>
                </div>
              </div>
            );
          })}
          <div className="c_notes">
            <p>Note: Coupon will be not applied on combo products</p>
          </div>
        </>
      }
    />
  );
};

export default ViewCoupon;
